import "./App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NetworkSection from "./components/NetworkSection";
import AccordionSections from "./components/AccordionSections";
import StepsSection from "./components/StepsSection";
import BuyingSection from "./components/BuyingSection";
import FooterCta from "./components/FooterCta";
import { SignupModal, ContactModal, CookieBanner } from "./components/Modals";
import { Toaster } from "sonner";

const Home = () => {
  const [signupOpen, setSignupOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  const openSignup = () => setSignupOpen(true);
  const openContact = () => setContactOpen(true);

  return (
    <div className="ws-page">
      <Header onSignup={openSignup} onContact={openContact} />
      <main>
        <Hero onSignup={openSignup} />
        <NetworkSection onSignup={openSignup} />
        <AccordionSections onSignup={openSignup} />
        <StepsSection />
        <BuyingSection />
        <FooterCta onContact={openContact} onSignup={openSignup} />
      </main>
      <SignupModal open={signupOpen} onOpenChange={setSignupOpen} />
      <ContactModal open={contactOpen} onOpenChange={setContactOpen} />
      <CookieBanner />
      <Toaster position="bottom-center" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
